// Auto-generated by typewriter from C# model
export enum ServiceEnvironment {
    Prod = 0,
    Sdf = 1,
    Gallatin = 2,
    Itar = 3,
    USNat = 4,
    USSec = 5,
    Bleu = 6,
    Delos = 7
}
